import htmlTags from './htmlTags';
import { pluginsEnabled } from '../plugins';
import specialCharactersSets from './specialCharactersSets';
import styles from './styles';
import tables from './tables';
import toolbarButtons from './toolbarButtons';
import { RTE_TOKEN_ATTR } from '../../constants';

export default {
  ...htmlTags,
  ...pluginsEnabled,
  ...specialCharactersSets,
  ...styles,
  ...tables,
  ...toolbarButtons,
  height: 400,
  htmlAllowedAttrs: [
    RTE_TOKEN_ATTR,
    'onclick',
    'href',
    'class',
    'style',
    'draggable',
    'ondragstart',
    'contenteditable',
    'onmousedown',
    'onmouseup',
    'onmouseover',
    'onmouseout',
    'onclick',
    'width',
  ],
  imageResize: false,
  listAdvancedTypes: false,
  quickInsertTags: '', // disable the quickInsert menu this way because it refuses to go away otherwise
  zIndex: 9999,
  key: '5C4F4A3G5D4B3cA5A4D4E3E4C2F1E3C1A2vDIG1QCYRWa1GPId1f1I1==',
};
